import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

const NumberField = ({
  name,
  schema,
  value,
  onChange,
  onBlur,
  error,
  touched,
  required = false,
}) => {
  const { title, description, minimum, maximum, multipleOf } = schema;
  const fieldId = `field-${name}`;

  const labelText = title || name;

  const handleChange = useCallback(
    (event) => {
      const newValue =
        event.target.value === '' ? '' : Number(event.target.value);
      onChange(name, newValue);
    },
    [name, onChange]
  );

  const handleBlur = useCallback(() => {
    onBlur(name);
  }, [name, onBlur]);

  return (
    <TextField
      fullWidth
      id={fieldId}
      label={labelText}
      type="number"
      name={name}
      value={value === undefined ? '' : value}
      onChange={handleChange}
      onBlur={handleBlur}
      error={touched && !!error}
      helperText={(touched && error) || description || ''}
      required={required}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        inputProps: {
          min: minimum,
          max: maximum,
          step: multipleOf,
        },
      }}
      aria-invalid={touched && !!error}
    />
  );
};

NumberField.propTypes = {
  name: PropTypes.string.isRequired,
  schema: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    minimum: PropTypes.number,
    maximum: PropTypes.number,
    multipleOf: PropTypes.number,
  }).isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  error: PropTypes.string,
  touched: PropTypes.bool,
  required: PropTypes.bool,
};

export default React.memo(NumberField);
